import { render, staticRenderFns } from "./publicItemIndex.vue?vue&type=template&id=52a5b5de&scoped=true&"
import script from "./publicItemIndex.vue?vue&type=script&lang=js&"
export * from "./publicItemIndex.vue?vue&type=script&lang=js&"
import style0 from "./publicItemIndex.vue?vue&type=style&index=0&id=52a5b5de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5b5de",
  null
  
)

export default component.exports